document.addEventListener('DOMContentLoaded', () => {
  const cartButtons = document.querySelectorAll('[data-open-cart]');
  const cartModal = document.getElementById('cart-modal');
  const cartItemsContainer = cartModal.querySelector('#cart-items');


  const footer = cartModal.querySelector('.cart-modal__footer');

  const cartOverlay = cartModal.querySelector('.cart-modal__overlay');
  const closeBtn = cartModal.querySelector('.cart-modal__close');
  const clearAllButton = cartModal.querySelector('.cart-modal__clear-all');
  let cartModalItemsSlider;

  const openCart = () => {
    document.body.classList.add('page--scroll-lock');
    cartModal.classList.add('cart-modal--visible');

    fetch('/?view=cart-modal') // Load cart modal via Liquid partial
      .then((res) => res.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newItems = doc.querySelector('#cart-items');
        if (newItems) {
          cartItemsContainer.innerHTML = newItems.innerHTML;
        }
        attachCartEvents();

        footer.innerHTML = doc.querySelector('.cart-modal__footer').innerHTML;

        fetch('/cart.js')
          .then((res) => res.json())
          .then((cart) => {
            console.log(cart);
            const bubbles = document.querySelectorAll('.cart-count-bubble');
            bubbles.forEach((bubble) => {
              bubble.textContent = cart.item_count > 0 ? cart.item_count : '0';
            });
          });
      });
  };

  // Make openCart available globally
  window.openCart = openCart;

  // Open modal
  cartButtons.forEach((btn) => {
    btn.addEventListener('click', openCart);
  });

  const closeCart = () => {
    document.body.classList.remove('page--scroll-lock');
    cartModal.classList.remove('cart-modal--visible');
  };

  if (clearAllButton) {
    clearAllButton.addEventListener('click', handleRemoveAll);
  }

  // Close modal

  if (closeBtn) {
    closeBtn.addEventListener('click', closeCart);
  }
  if (cartOverlay) {
    cartOverlay.addEventListener('click', closeCart);
  }

  // Attach events for quantity changes & remove
  function attachCartEvents() {
    document.querySelectorAll('.cart-item input').forEach((input) => {
      input.addEventListener('change', handleQtyInputChange);
    });
    document.querySelectorAll('.qty-btn').forEach((btn) => {
      btn.addEventListener('click', handleQtyChange);
    });
    document.querySelectorAll('.remove-item').forEach((btn) => {
      btn.addEventListener('click', handleRemove);
    });
  }

  // Update quantity
  function handleQtyChange(e) {
    const btn = e.target;
    const item = btn.closest('.cart-item');
    const key = item.dataset.key;
    const input = item.querySelector('input');
    let qty = parseInt(input.value);

    if (btn.dataset.action === 'increase') qty++;
    if (btn.dataset.action === 'decrease' && qty > 1) qty--;

    updateCart(key, qty);
  }

  function handleQtyInputChange(e) {
    const input = e.target;
    const item = input.closest('.cart-item');
    const key = item.dataset.key;
    const qty = parseInt(input.value);

    updateCart(key, qty);
  }

  // Remove item
  function handleRemove(e) {
    const item = e.target.closest('.cart-item');
    const key = item.dataset.key;
    updateCart(key, 0);
  }

  function handleRemoveAll(e) {
    e.preventDefault();
    fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }).then(() => {
      openCart();
    });
  }

  // AJAX request to Shopify
  function updateCart(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty }),
    }).then(() => openCart()); // Reload cart modal after update
  }

  // Close search drawer on Escape key press
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeCart();
    }
  });

  // Removed items slider; using simple list in #cart-items now

  const cartLikeItemsSlider = new Swiper('.cart-modal__like-items.swiper', {
    slidesPerView: 'auto',
    spaceBetween: 2,
    navigation: {
      nextEl: '.cart-modal__nav-button.cart-modal__nav-button--next',
      prevEl: '.cart-modal__nav-button.cart-modal__nav-button--prev',
    },
  });

  // Update cart when adding from like items inside the modal
  cartModal.addEventListener('click', async (e) => {
    const likeItem = e.target.closest('.cart-modal__like-item');
    if (!likeItem) return;

    // Size option chosen
    const sizeBtn = e.target.closest(
      '.plp-card__actions .plp-card__size-item.plp-card__size-item--in-stock'
    );
    if (sizeBtn) {
      const variantId = sizeBtn.dataset.variantId;
      if (!variantId) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        });
        console.log('added_to_cart');
        openCart();
      } catch (err) {
        console.error('Error adding variant from like item', err);
      }
      return;
    }

    // Add-to-cart button (when variantId already set)
    const addBtn = e.target.closest('.plp-card__actions .plp-card__add-to-cart');
    if (addBtn) {
      const variantId = addBtn.dataset.variantId;
      if (!variantId) return; // fallback to open size options
      e.preventDefault();
      e.stopImmediatePropagation();
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        });
        console.log('added_to_cart');
        openCart();
      } catch (err) {
        console.error('Error adding like item', err);
      }
    }
  });
});
